import React, {Component, Fragment} from 'react';
import MyContent from '../../layout/MyContent';
import Typography from '@material-ui/core/Typography';
import Pagination from '@material-ui/lab/Pagination';
import rf from '../../requests/requests';
import createNotification from '../../common/Notifications';

import './style.scss';
import ReviewsTable from "./ReviewsTable";

class ReviewsList extends Component {
   constructor(props) {
    super(props);
    this.state = {
      reviews: [],
      pagination: {
        page: null,
        total: null,
      },
      page: 1,
      review_id: null,
      reviewPrams: {},
    };
  }

  componentDidMount() {
    this.getReviews();
  }

  getReviews = (params) => {
    rf.get(`/admin/reviews`, { params: params })
      .then(res => {
        this.setState(state => ({
          reviews: res.data.reviews,
          pagination: res.data.meta.pagination,
        }));
      })
      .catch(error => {
        const message = error.response && error.response.data && error.response.data.errors[0]&& error.response.data.errors[0].message;
        createNotification(message);
      });
  };

  paginationPractitioners = () => {
    const total = this.state.pagination.total;

    if(total >= 10) {
      return (
        <div style={{margin: '30px 0px', textAlign: 'center'}}>
          <Pagination className="pagination" count={Math.ceil(total / 10)} page={this.state.page} onChange={this.handleChangePagination} variant="outlined" shape="rounded" />
          <Typography style={{marginTop: '16px'}} className="page_of">{this.state.page} /  {(total / 10) < 1 ? '1' : Math.ceil(total / 10)}</Typography>
        </div>
      )
    }
  };

  handleChangePagination = (event, value) => {
    this.setState({ page: value});
    const params = {
      page: value
    }
    this.getReviews(params)
  };

  render() {
    return (
      <MyContent name='reviews' header='レビュー'>
        <Fragment>
          <ReviewsTable
            reviews={this.state.reviews}
          />
          {this.paginationPractitioners()}
        </Fragment>
      </MyContent>
    );
  };
}

export default ReviewsList;
